import FlexPane from './_flex-pane.js'
import CountryIcon from './_country-icon.js'
import Text from './_text.js'
import MiniEventItem from './_mini-event-item.js'
import InPlayMenu from './_in-play-menu.js'

export default {
  name: 'QuickEventsNavigation',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 4px',
        },
      },
    },
    groupContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    groupHeaderContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          height: '40px',
          padding: '0 8px',
        },
      },
    },
    countryIcon: {
      configSet: CountryIcon,
      configValues: {},
    },
    groupHeaderLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
      },
    },
    eventItemsContainer: {
      configSet: FlexPane,
      configValues: {
        separator: {
          style: {
            size: '1px',
            margin: '0 8px',
          },
        },
        style: {
          flexDirection: 'column',
        },
      },
    },
    eventItem: {
      configSet: MiniEventItem,
      configValues: {
        container: {
          style: {
            base: {
              gap: '8px',
              minHeight: '57px',
              maxHeight: '78px',
              flexDirection: 'row',
            },
          },
        },
        content: {
          eventTimingStatus: {
            showStreamIcon: false,
            splitDateTime: true,
            container: {
              style: {
                base: {
                  flexGrow: 0,
                },
              },
            },
            dateTimeContainer: {
              separator: {
                style: {
                  size: 0,
                },
              },
              style: {
                flexDirection: 'column-reverse',
                alignItems: 'center',
                width: '56px',
              },
            },
            timeFormatter: {
              format: 'SHORT_TIME',
            },
            dateFormatter: {
              showTodayAndTomorrowLabels: false,
              format: 'NUMERIC_SHORT_DATE',
            },
          },
        },
        contentActive: {
          eventTimingStatus: {
            showStreamIcon: false,
            splitDateTime: true,
            timeFormatter: {
              format: 'SHORT_TIME',
            },
            dateFormatter: {
              showTodayAndTomorrowLabels: false,
              format: 'NUMERIC_SHORT_DATE',
            },
            container: {
              style: {
                base: {
                  flexGrow: 0,
                },
              },
            },
            dateTimeContainer: {
              separator: {
                style: {
                  size: 0,
                },
              },
            },
          },
        },
      },
    },
    inPlayMenu: {
      configSet: InPlayMenu,
      configValues: {
        redirect: false,
        navigationMenu: {
          overlayInteractionOnItemClick: false,
        },
        allItem: {
          hide: true,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
